import React from "react";
import DateCell from "$components/table/cells/date";
import { SelectColumnFilter, DateFilter } from "$components/table/components/filters/filter";
import { getTerm } from "$stores/dictionary";

export const STATUS_OPTIONS = [
    { value: "Active", text: "Active" },
    { value: "Complete", text: "Complete" },
    { value: "Archived", text: "Archived" },
];

export const getFocusTypeLabels = () => ({
    PartnerClients: `${getTerm("parentCrm")}'s ${getTerm("parentClients")}`,
    PracticeArea:   getTerm("serviceLine"),
    Industry:       getTerm("industry"),
    TopClients:     `Top ${getTerm("parentClients")}`,
    AtRiskClients:  `At-Risk ${getTerm("parentClients")}`,
    MatterType:     getTerm("projectType"),
});

export const buildDefaultColumns = ({ ownerOptions = [] } = {}) => {
    const focusTypeOptions = [
        { value: "PartnerClients", text: `${getTerm("parentCrm")}'s ${getTerm("parentClients")}` },
        { value: "PracticeArea",   text: getTerm("serviceLine") },
        { value: "Industry",       text: getTerm("industry") },
        { value: "TopClients",     text: `Top ${getTerm("parentClients")}` },
        { value: "AtRiskClients",  text: `At-Risk ${getTerm("parentClients")}` },
        { value: "MatterType",     text: getTerm("projectType") },
    ];
    return [
        {
            Header: () => `${getTerm("initiative")} Name`,
            accessorKey: "name",
            id: "name",
            size: 240,
            className: "-sticky-left",
        },
        {
            Header: () => "Focus Type",
            accessorKey: "focusTypeLabel",
            id: "focusTypeLabel",
            size: 150,
            Filter: SelectColumnFilter,
            filterOptions: { options: focusTypeOptions },
        },
        {
            Header: () => getTerm("initiativeStatus"),
            accessorKey: "status",
            id: "status",
            size: 100,
            Filter: SelectColumnFilter,
            filterOptions: { options: STATUS_OPTIONS },
        },
        {
            Header: () => "Target Date",
            accessorKey: "targetDate",
            id: "targetDate",
            size: 130,
            sortDescFirst: true,
            Filter: DateFilter,
            filterOptions: { label: "On or after" },
            Cell: ({ value }) => <DateCell value={value} noValue="—" />,
        },
        {
            Header: () => "Shortlist",
            accessorKey: "shortlistCount",
            id: "shortlistCount",
            size: 90,
            sortDescFirst: true,
            enableColumnFilter: false,
            Cell: ({ value }) => value === 0 ? "—" : value,
        },
        {
            Header: () => "Last Activity",
            accessorKey: "lastActivityDate",
            id: "lastActivityDate",
            size: 130,
            sortDescFirst: true,
            enableColumnFilter: false,
            Cell: ({ value }) => <DateCell value={value} noValue="—" />,
        },
        {
            Header: () => getTerm("initiativeOwner"),
            accessorKey: "ownerName",
            id: "ownerName",
            size: 160,
            Filter: SelectColumnFilter,
            filterOptions: { options: ownerOptions },
        },
        {
            Header: () => "Team Size",
            accessorKey: "teamSize",
            id: "teamSize",
            size: 70,
            sortDescFirst: true,
            enableColumnFilter: false,
        },
    ];
};
